var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 88,
    viewBox: "0 0 93 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5612 0H10.8832C4.88221 0 0 4.90605 0 10.9373V77.0626C0 83.0939 4.88221 88 10.8832 88H81.5612C87.5622 88 92.4444 83.0939 92.4444 77.0626V10.9381C92.4452 4.90683 87.5622 0 81.5612 0ZM87.777 77.0626C87.777 80.5064 84.9885 83.3082 81.562 83.3082H10.8832C7.45674 83.3082 4.66824 80.5064 4.66824 77.0626V27.3086H87.777V77.0626V77.0626ZM87.777 22.6168H4.66824V10.9381C4.66824 7.49435 7.45674 4.69257 10.8832 4.69257H81.5612C84.9877 4.69257 87.7762 7.49435 87.7762 10.9381V22.6168H87.777Z",
    fill: "#373334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 12.4452H11.5554V16.8897H18.6665V12.4452Z",
    fill: "#373334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3305 12.4452H22.2194V16.8897H29.3305V12.4452Z",
    fill: "#373334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0006 12.4452H33.7784V16.8897H40.0006V12.4452Z",
    fill: "#373334"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8626 71.1111H33.2481C34.5225 71.1111 35.5554 70.0578 35.5554 68.7582V42.353C35.5554 41.0534 34.5225 40 33.2481 40H13.8626C12.5882 40 11.5554 41.0534 11.5554 42.353V68.7582C11.5554 70.0578 12.5882 71.1111 13.8626 71.1111Z",
    fill: "#373334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2222 41.7773H40.8889V46.2217H62.2222V41.7773Z",
    fill: "#373334"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2222 52.4442H40.8889V57.7775H78.2222V52.4442Z",
    fill: "#373334"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2222 63.9979H40.8889V68.4423H78.2222V63.9979Z",
    fill: "#373334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.171d31e55f301308a5cdfd084245e929.svg";
export { ForwardRef as ReactComponent };